import PropTypes from 'prop-types';
import cc from 'classcat';

import Modal from '../Modal';
import Button from '../Button';
import { themes } from '../../lib/themes';

import styles from './styles.module.scss';

const NoticeModal = ({
  theme,
  content: { title, ctaLabel } = {},
  onClose = () => {},
  children,
  ctaClassName,
  ...modalProps
}) => (
  <Modal title={title} onClose={onClose} {...modalProps}>
    <header>
      <h2 className={styles.title}>{title}</h2>
    </header>
    {children}
    <footer className={styles.actions}>
      <Button
        onClick={onClose}
        theme={theme}
        variant="secondary"
        className={cc([styles.close, ctaClassName])}
      >
        {ctaLabel}
      </Button>
    </footer>
  </Modal>
);

NoticeModal.propTypes = {
  theme: PropTypes.oneOf(themes),
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    ctaLabel: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
};

export default NoticeModal;
